module.exports = __webpack_public_path__ + "img/88.4baaad6f.webp";